module.exports = __webpack_public_path__ + "static/media/main idea.d091e90f.mp3";